<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Login from '../components/Login.svelte';

  onMount(() => {
    const isAuthenticated = window.localStorage.getItem('isAuthenticated');
    if (isAuthenticated) navigate('/');
  })
</script>

<main>
  <Login />
</main>